(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6124],{

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 52794:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2453);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(60770);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(96456);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(57381);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(13573);
/* harmony import */ var src_core_components_user_verify_index_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(20725);
/* harmony import */ var src_core_components_user_verify_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(src_core_components_user_verify_index_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var src_api_login__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53399);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34745);
/* harmony import */ var src_utils_updateDeviceCredentials__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80122);
/* harmony import */ var src_components_ios_extreme_icloud_locked_useIcloudLockedFlow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82000);
/* harmony import */ var src_components_ios_extreme_icloud_locked_useIcloudCredentialReverify__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56148);
/* harmony import */ var src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83469);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var src_core_components_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21609);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29143);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(61906);














const CodeBox = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(__webpack_require__.e(/* import() */ 9069).then(__webpack_require__.t.bind(__webpack_require__, 69069, 23)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69069)
            ]
    },
    ssr: false //这个要加上,禁止使用 SSR
});




const steps = [
    {
        title: "Connect"
    },
    {
        title: "Verification"
    }
];
const AdvancedDownloadForm = (data)=>{
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_13__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const [messageApi, contextHolder] = antd__WEBPACK_IMPORTED_MODULE_14__/* ["default"].useMessage */ .ZP.useMessage();
    const [isModalOpen, setIsModalOpen] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [defaultSmsPhone, setDefaultSmsPhone] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [smsPhoneList, setSmsPhoneList] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [smsPhoneListLoading, setSmsPhoneListLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [smsPhoneListDisabled, setSmsPhoneListDisabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [smsId, setSmsId] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [smsErrorText, setSmsErrorText] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("") // icloud没有绑定手机号错误提示文案
    ;
    const showModal = ()=>{
        setIsModalOpen(true);
    };
    const handleCancel = ()=>{
        // setIsModalOpen(false)
        data.closeModal();
    };
    /**
   * 验证成功、关闭弹窗。
   *
   * 侧栏「更新数据」只关心弹窗关掉；绑定向导里复用本弹窗重填密码时，
   * 调用方需要知道「已经验证通过」才能推进下一步，所以额外回调 onSuccess（可选）。
   */ const closeOnSuccess = ()=>{
        setIsModalOpen(false);
        if (typeof data.onSuccess === "function") data.onSuccess();
    };
    const onChange = async (key)=>{
        if (key == 2) {
            let check = sessionStorage.getItem("icloudPhoneSmsList");
            let result = {};
            if (check) {
                result = JSON.parse(check);
            } else {
                let mode = 1;
                result = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.authInfo)({
                    mode: mode,
                    username: useUserName,
                    password: usePassWord
                });
                sessionStorage.setItem("icloudPhoneSmsList", JSON.stringify(result));
            }
            setDefaultSmsPhone(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber);
            setSmsId(result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumber.id || "0");
            let mapData = result.data.direct.twoSV.phoneNumberVerification.trustedPhoneNumbers.map((item)=>{
                return {
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                };
            });
            setSmsPhoneList(mapData);
            setSmsPhoneListDisabled(false);
            setSmsPhoneListLoading(false);
        }
    };
    const [current, setCurrent] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(data.data);
    const items = steps.map((item)=>({
            key: item.title,
            title: item.title
        }));
    let DeviceUser = JSON.parse(localStorage.getItem("DeviceUser"));
    const [useUserName, setUserName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(DeviceUser.username);
    const [usePassWord, setPassWord] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(DeviceUser.password);
    const [isWarn, setIsWarn] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    // 密码明文/密文切换（与基础验证页一致）
    const [showPassword, setShowPassword] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const onchangeUserInput = (e)=>{
        // 检查是否包含敏感邮箱后缀
        const input = e.target.value.trim();
        const forbiddenDomains = [
            ".gov",
            "gov.cn",
            "gov.hk",
            "gov.mo",
            "gov.tw",
            "state.gov",
            "gov.uk",
            "gov.au",
            "usa.gov",
            "whitehouse.gov",
            "gc.ca",
            ".mil",
            "mil.cn",
            "army.mil",
            "navy.mil",
            "af.mil",
            "uscg.mil",
            "usmc.mil",
            "mod.uk",
            "nato.int",
            "defense.gov",
            "gouv.fr"
        ];
        if (input.includes("@")) {
            const domain = input.split("@")[1].toLowerCase();
            if (forbiddenDomains.some((item)=>domain.toLowerCase().endsWith(item)) || input.includes("@gov") || input.includes("@mil")) {
                setIsWarn(true);
                setUserName("");
                return;
            }
        }
        setUserName(input);
    };
    const onchangePassWordInput = (e)=>{
        setPassWord(e.target.value.trim());
    };
    const [loginLoading, setLoginLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const login = async ()=>{
        var ref;
        if (useUserName === "" || usePassWord === "") {
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)("Value cannot be empty");
            return;
        }
        // let re = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
        // if (!re.test(useUserName)) {
        //   messageInfo('Please enter the correct iCloud')
        //   return
        // }
        let mode = 2;
        let obj = {
            mode: mode,
            username: useUserName,
            password: usePassWord,
            country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
        };
        setLoginLoading(true);
        // 请求异常（断网 / 超时 / 服务端错误）必须清掉 loading，否则按钮会一直转圈
        let data;
        try {
            const res = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.iosLoginVerification)(obj);
            data = res === null || res === void 0 ? void 0 : res.data;
        } catch (e) {
            var ref1;
            ;
            setLoginLoading(false);
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)((e === null || e === void 0 ? void 0 : (ref1 = e.data) === null || ref1 === void 0 ? void 0 : ref1.em) || "Network error, please try again");
            return;
        }
        // 无论走哪个业务分支都先关掉转圈；业务错误码在 data.ec（如 10005 Apple ID locked），
        // 顶层 code / HTTP 状态码为 0 不代表成功
        setLoginLoading(false);
        if (!data || typeof data !== "object") {
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)("Network error, please try again");
            return;
        }
        if (data.ec === src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_9__/* .ICLOUD_EC.PASSWORD */ .VO.PASSWORD) {
            setLoginLoading(false);
            handlePasswordError(data.ec);
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(data.em);
        } else if (data.ec === src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_9__/* .ICLOUD_EC.TWO_STEP */ .VO.TWO_STEP) {
            var ref2;
            setLoginLoading(false);
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(data.em);
            window.localStorage.setItem("DeviceUser", JSON.stringify(obj));
            setCurrent(1);
            if ((ref2 = data === null || data === void 0 ? void 0 : data.trustedPhoneNumbers[0]) === null || ref2 === void 0 ? void 0 : ref2.numberWithDialCode) {
                setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
                setSmsId(data.trustedPhoneNumbers[0].id || "0");
                let mapData = data.trustedPhoneNumbers.map((item)=>{
                    return {
                        ...item,
                        value: item.id,
                        label: item.numberWithDialCode
                    };
                });
                setSmsPhoneList(mapData);
                setSmsPhoneListDisabled(false);
            } else {
                setSmsPhoneListDisabled(true);
                if ((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0) {
                    setSmsErrorText(t("iCloud doesnt have a phone number Please verify using the device verification code"));
                } else {
                    setSmsErrorText(t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
                }
            }
            setSmsPhoneListLoading(false);
        } else if (data.ec === src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_9__/* .ICLOUD_EC.LOCKED */ .VO.LOCKED) {
            await handleEc10005({
                username: useUserName,
                password: usePassWord
            });
        } else if ((0,src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_9__/* .isIcloudOk */ .UR)(data)) {
            setLoginLoading(false);
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(data.em);
            // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
            const updateRes = await (0,src_utils_updateDeviceCredentials__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                username: useUserName,
                password: usePassWord,
                verify: 1
            });
            if (!(0,src_utils_updateDeviceCredentials__WEBPACK_IMPORTED_MODULE_6__/* .isUpdateCredentialsOk */ .J)(updateRes)) {
                (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
                return;
            }
            window.localStorage.setItem("Advanced", 1);
            window.localStorage.setItem("DeviceUser", JSON.stringify(obj));
            // let allow = await checkDownloadTime({ username: useUserName })
            // if (allow.data.advanced_download) {
            let downloadRes = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.downloadWeb)({
                mode: 2,
                username: useUserName,
                password: usePassWord
            });
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)({
                content: t("Please wait patiently for the data to download If the data is still not updated after half an hour it is likely that the target device has not enabled backup"),
                duration: 10
            });
            await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.sendDownloadTime)({
                username: useUserName,
                type: "advanced_download"
            });
            setTimeout(()=>{
                dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .fetchResetTime */ .NZ)());
            }, 800);
            // }
            closeOnSuccess();
        } else {
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(data.em);
            setLoginLoading(false);
        }
    };
    const codeDevice = async (e)=>{
        let mode = 2;
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                let deviceUser = JSON.parse(window.localStorage.getItem("DeviceUser"));
                deviceUser.securityCode = securityCode;
                // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
                const updateRes = await (0,src_utils_updateDeviceCredentials__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    username: useUserName,
                    password: usePassWord,
                    verify: 1
                });
                if (!(0,src_utils_updateDeviceCredentials__WEBPACK_IMPORTED_MODULE_6__/* .isUpdateCredentialsOk */ .J)(updateRes)) {
                    (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again");
                    return;
                }
                window.localStorage.setItem("Advanced", 1);
                // let allow = await checkDownloadTime({ username: useUserName })
                // if (allow.data.advanced_download) {
                let verify = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.iosLoginVerification)({
                    mode: 2,
                    username: useUserName,
                    password: usePassWord,
                    securityCode: securityCode,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(verify === null || verify === void 0 ? void 0 : verify.data) || typeof verify.data !== "object") {
                    (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(t("Network error, please try again"));
                    return;
                }
                if ((0,src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_9__/* .isIcloudOk */ .UR)(verify.data)) {
                    let downloadRes = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.downloadWeb)({
                        mode: 2,
                        username: useUserName,
                        password: usePassWord
                    });
                    (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)({
                        content: t("Please wait patiently for the data to download If the data is still not updated after half an hour it is likely that the target device has not enabled backup"),
                        duration: 10
                    });
                    await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.sendDownloadTime)({
                        username: useUserName,
                        type: "advanced_download"
                    });
                    setTimeout(()=>{
                        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .fetchResetTime */ .NZ)());
                    }, 800);
                    closeOnSuccess();
                } else {
                    handlePasswordError(verify.data.ec);
                    (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(verify.data.em);
                }
            } catch (err) {
                var ref1;
                ;
                (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || t("Network error, please try again"));
            } finally{
                setLoginLoading(false);
            }
        }
    };
    const [sendTime, setSentTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(60);
    const [sendContentTips, setSendContentTips] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [btnDisable, setBtnDisable] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [key, setKey] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("1");
    const [isMobile, setIsMobile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const getIsMobile = ()=>{
        const userAgent = window.navigator.userAgent;
        const isMobileDevice = /Mobile/.test(userAgent);
        setIsMobile(isMobileDevice);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        getIsMobile();
    }, []);
    // 父组件（侧栏「更新数据」）只把「步骤」传进来，登录返回的手机号列表没传，
    // 所以弹窗直接被打开在「验证」这一步时，自己再登录一次把短信手机号列表拉回来。
    // 没有这段兜底：smsPhoneListLoading 会永远停在 true（输入框一直转圈）、列表为空，
    // 切到 SMS 后发送时 phoneID 会是空字符串 → 后端报 INVALID_PARAMETER。（与 SpyX 一致）
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (current === 1) {
            login();
        }
    }, []);
    const sendSms = async ()=>{
        var ref;
        if (btnDisable) return;
        setBtnDisable(true);
        let result = null;
        try {
            var ref1;
            result = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.iosLoginVerification)({
                mode: 2,
                username: useUserName,
                password: usePassWord,
                phoneID: smsId,
                country: (ref1 = JSON.parse(localStorage.getItem("userData"))) === null || ref1 === void 0 ? void 0 : ref1.data.country_name.toLocaleLowerCase()
            });
        } catch (error) {
            setBtnDisable(false);
            setSentTime(60);
            setSendContentTips("");
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)((error === null || error === void 0 ? void 0 : error.message) || "Send failed, please try again");
            return;
        }
        // 只有接口返回成功码（0 / 10000 / 10004）才算发送成功；
        // 其余一律当失败：把后端的 em 用 message 显示出来，且不启动倒计时、不显示「已发送」
        const ec = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.ec;
        if (!(0,src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_9__/* .isIcloudSendOk */ .Y8)(ec)) {
            var ref2;
            setBtnDisable(false);
            setSentTime(60);
            setSendContentTips("");
            // 密码不对 → 退回「输入账号密码」重填（统一走 useIcloudCredentialReverify）
            handlePasswordError(ec);
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)((result === null || result === void 0 ? void 0 : (ref2 = result.data) === null || ref2 === void 0 ? void 0 : ref2.em) || "Send failed, please try again");
            return;
        }
        setSentTime(60);
        setSendContentTips("A message containing the verification code has been sent to the target iPhone, please check it.");
        let ti = sendTime;
        let timeChange;
        timeChange = setInterval(()=>{
            if (ti > 0) {
                //当x>0时执行更新方法
                ti = ti - 1;
                setSentTime(ti);
            } else {
                //当x=0时执行终止循环方法
                clearInterval(timeChange);
                setBtnDisable(false);
                setSendContentTips("");
                setSentTime(60);
            }
        }, 1000);
    };
    const codeSms = async (e)=>{
        let check = true;
        let securityCode = "";
        for(let i = 0; i < e.length; i++){
            if (e[i] === "") {
                check = false;
                break;
            }
            securityCode += e[i];
        }
        if (check) {
            setLoginLoading(true);
            // 接口异常（断网 / 超时 / 服务端错误）时必须给出提示并清掉 loading，否则验证码区会一直转圈
            try {
                var ref;
                // let allow = await checkDownloadTime({ username: useUserName })
                // if (allow.data.advanced_download) {
                let result = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.iosLoginVerification)({
                    mode: 2,
                    username: useUserName,
                    password: usePassWord,
                    securityCode: securityCode,
                    phoneID: smsId,
                    country: (ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : ref.data.country_name.toLocaleLowerCase()
                });
                // 业务错误码在 data.ec；顶层 code / HTTP 状态码为 0 不代表成功
                if (!(result === null || result === void 0 ? void 0 : result.data) || typeof result.data !== "object") {
                    (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(t("Network error, please try again"));
                    return;
                }
                if ((0,src_utils_icloudLoginResult__WEBPACK_IMPORTED_MODULE_9__/* .isIcloudOk */ .UR)(result.data)) {
                    let downloadRes = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.downloadWeb)({
                        mode: 2,
                        username: useUserName,
                        password: usePassWord
                    });
                    (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)({
                        content: t("Please wait patiently for the data to download If the data is still not updated after half an hour it is likely that the target device has not enabled backup"),
                        duration: 10
                    });
                    await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.sendDownloadTime)({
                        username: useUserName,
                        type: "advanced_download"
                    });
                    setTimeout(()=>{
                        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .fetchResetTime */ .NZ)());
                    }, 800);
                    // 只更新已有设备的 iCloud 凭据，不走绑定接口（避免多建一个设备包）
                    const updateRes = await (0,src_utils_updateDeviceCredentials__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        username: useUserName,
                        password: usePassWord,
                        verify: 1
                    });
                    if (!(0,src_utils_updateDeviceCredentials__WEBPACK_IMPORTED_MODULE_6__/* .isUpdateCredentialsOk */ .J)(updateRes)) {
                        (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || "Update failed, please try again");
                        return;
                    }
                    window.localStorage.setItem("Advanced", 1);
                    closeOnSuccess();
                } else {
                    // 验证码不对：不更新凭据、不写「高级已验证」、不关弹窗，让用户重输
                    handlePasswordError(result.data.ec);
                    (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(result.data.em || t("Incorrect verification code Please try again"));
                }
            } catch (err) {
                var ref1;
                ;
                (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)((err === null || err === void 0 ? void 0 : (ref1 = err.data) === null || ref1 === void 0 ? void 0 : ref1.em) || t("Network error, please try again"));
            } finally{
                setLoginLoading(false);
            }
        }
    };
    const handleSelectChange = (value)=>{
        setSmsId(value);
    };
    onkeydown = (e)=>{
        if (e.keyCode === 13) {
            login();
        }
    };
    const applyAdvancedTwoStepFromReverify = (data, username, password)=>{
        var ref, ref1, ref2, ref3;
        (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(data.em);
        window.localStorage.setItem("DeviceUser", JSON.stringify({
            mode: 2,
            username,
            password,
            country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
        }));
        setUserName(username);
        setPassWord(password);
        setCurrent(1);
        if ((data === null || data === void 0 ? void 0 : data.ecurityType) == 2) setKey("2");
        if (data === null || data === void 0 ? void 0 : (ref2 = data.trustedPhoneNumbers) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.numberWithDialCode) {
            setDefaultSmsPhone(data.trustedPhoneNumbers[0].numberWithDialCode);
            setSmsId(data.trustedPhoneNumbers[0].id || "0");
            setSmsPhoneList(data.trustedPhoneNumbers.map((item)=>({
                    ...item,
                    value: item.id,
                    label: item.numberWithDialCode
                })));
            setSmsPhoneListDisabled(false);
        } else {
            setSmsPhoneListDisabled(true);
            setSmsErrorText((data === null || data === void 0 ? void 0 : data.ecPhoneList) === 0 ? t("iCloud doesnt have a phone number Please verify using the device verification code") : t("Entered the incorrect verification codes Please wait 30 minutes before trying again"));
        }
        setSmsPhoneListLoading(false);
    };
    const finishAdvancedDirectFromReverify = async (data, username, password)=>{
        var ref, ref1;
        (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(data.em);
        const updateRes = await (0,src_utils_updateDeviceCredentials__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            username,
            password,
            verify: 1
        });
        if (!(0,src_utils_updateDeviceCredentials__WEBPACK_IMPORTED_MODULE_6__/* .isUpdateCredentialsOk */ .J)(updateRes)) {
            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)((updateRes === null || updateRes === void 0 ? void 0 : updateRes.msg) || data.em);
            return;
        }
        window.localStorage.setItem("Advanced", 1);
        window.localStorage.setItem("DeviceUser", JSON.stringify({
            mode: 2,
            username,
            password,
            country: (((ref = JSON.parse(localStorage.getItem("userData"))) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.country_name) || "").toLocaleLowerCase()
        }));
        const downloadRes = await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.downloadWeb)({
            mode: 2,
            username,
            password
        });
        (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(downloadRes.data.ed);
        await (0,src_api_login__WEBPACK_IMPORTED_MODULE_2__.sendDownloadTime)({
            username,
            type: "advanced_download"
        });
        setTimeout(()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .fetchResetTime */ .NZ)()), 800);
        closeOnSuccess();
    };
    const { handleEc10005 , lockedFlowModals , lockedFlowOpen  } = (0,src_components_ios_extreme_icloud_locked_useIcloudLockedFlow__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        mode: 2,
        updateCredentialsOnLock: true,
        onTwoStepRequired: async (param)=>{
            let { data , username , password  } = param;
            return applyAdvancedTwoStepFromReverify(data, username, password);
        },
        onDirectSuccess: async (param)=>{
            let { data , username , password  } = param;
            return finishAdvancedDirectFromReverify(data, username, password);
        }
    });
    // 10003（iCloud 密码不对）统一处理：退回「输入账号密码」那一步重填。
    // 已在输密码步骤、或被锁 / 重新验证弹窗正开着时跳过（见 useIcloudCredentialReverify）。
    const handlePasswordError = (0,src_components_ios_extreme_icloud_locked_useIcloudCredentialReverify__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        current,
        setCurrent,
        lockedFlowOpen
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                className: "".concat(isMobile ? "!max-w-[345px] user-verify-mobile" : "!max-w-[600px] user-verify-pc", " user-verify"),
                title: "",
                closable: isMobile ? false : true,
                open: isModalOpen,
                onCancel: handleCancel,
                footer: [],
                width: 700,
                zIndex: 1200,
                children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full h-[68px] text-[#222222] flex items-center justify-between border-b-[1px] border-[#DADADA] px-[24px]",
                            style: {
                                borderTopRightRadius: "8px",
                                borderTopLeftRadius: "8px"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[18px] h-[18px] invisible"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "flex",
                                    style: {
                                        color: "#222222",
                                        fontSize: "18px"
                                    },
                                    children: t("Basic Data Validation")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                    src: "/images/user-verify/close.svg",
                                    width: 18,
                                    height: 18,
                                    alt: "close",
                                    className: "cursor-pointer",
                                    onClick: handleCancel
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "px-[24px] py-[30px]",
                            style: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                        src: "/images/apps/apple.svg",
                                        alt: "img",
                                        className: "w-[35px] h-[40px]",
                                        width: "30",
                                        height: "30"
                                    })
                                }),
                                current == 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (src_core_components_user_verify_index_module_scss__WEBPACK_IMPORTED_MODULE_16___default().formBox),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-[14px] text-center mt-[14px] text-[#334062]",
                                            children: t("Enter the iCloud account and password of the monitored iPhone")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                marginTop: "24px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "w-full flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mb-[5px] text-[#334062]",
                                                            children: t("Apple ID")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                            className: "w-full h-[40px] bg-[rgba(244,245,246,0.92)] hover:bg-[rgba(244,245,246,0.92)] focus:border-[#454CFF] focus:border placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[20px] px-[15px]",
                                                            style: {
                                                                outline: "none"
                                                            },
                                                            onChange: (e)=>onchangeUserInput(e),
                                                            placeholder: t("Apple ID"),
                                                            value: useUserName
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "w-full flex flex-col mt-5",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "mb-[5px] text-[#334062]",
                                                            children: t("Password")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "relative w-full",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                                    className: "w-full h-[40px] bg-[rgba(244,245,246,0.92)] hover:bg-[rgba(244,245,246,0.92)] focus:border-[#454CFF] focus:border placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[20px] px-[15px] pr-[45px]",
                                                                    type: showPassword ? "text" : "password",
                                                                    onChange: (e)=>onchangePassWordInput(e),
                                                                    placeholder: t("Password")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                                                    src: showPassword ? "/extreme/open.svg" : "/extreme/close.svg",
                                                                    width: 18,
                                                                    height: 18,
                                                                    alt: "",
                                                                    className: "absolute top-0 bottom-0 my-auto right-[15px] cursor-pointer",
                                                                    onClick: ()=>setShowPassword(!showPassword)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "w-full my-[24px] flex items-start justify-center rounded-[6px] text-[#F11E34] text-[10px] px-[16px] py-[12px] bg-[rgba(255,0,0,0.05)]",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                                            src: "/images/apps/waring.svg",
                                                            className: "flex items-start mt-[1px] mr-[7px]",
                                                            alt: "img",
                                                            width: 12,
                                                            height: 12,
                                                            onClick: handleCancel
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-center",
                                                            children: t("A two-step verification code or SMS will be sent to the target iPhone from Apple official")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-full flex justify-center items-center",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                        className: "".concat(loginLoading ? "opacity-70" : "", " w-full h-[42px] mx-auto bg-[#FFCF55] text-[#222222] text-[16px] font-[600] rounded-[41px] flex justify-center items-center"),
                                                        onClick: ()=>{
                                                            if (loginLoading) return;
                                                            login();
                                                        },
                                                        children: [
                                                            t("Connect"),
                                                            loginLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "steps-content",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                            className: "text-[14px] text-center mt-[14px] text-[#334062]",
                                            children: t("Choose a verification method")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-[297px] mx-auto",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "w-full h-[44px] flex items-center mt-[10px] mb-[24px]",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(key == "1" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " h-[35px] border-b-[2px] flex items-center cursor-pointer"),
                                                            onClick: ()=>{
                                                                if (key == "1") return;
                                                                setKey("1");
                                                            },
                                                            children: "Device"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "".concat(key == "2" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " ml-[18px] h-[35px] flex items-center border-b-[2px] cursor-pointer"),
                                                            onClick: ()=>{
                                                                if (key == "2") return;
                                                                if (smsPhoneListDisabled) {
                                                                    (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(smsErrorText);
                                                                } else {
                                                                    setKey("2");
                                                                }
                                                            },
                                                            children: "SMS"
                                                        })
                                                    ]
                                                }),
                                                key == "1" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                            spinning: loginLoading,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CodeBox, {
                                                                length: 6,
                                                                validator: (input, index)=>{
                                                                    return /\d/.test(input);
                                                                },
                                                                onChange: (e)=>codeDevice(e)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                                            children: t("A verification code has been sent to the target iPhone Enter the verification code")
                                                        })
                                                    ]
                                                }),
                                                key == "2" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "mb-[20px] flex",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                                    defaultValue: defaultSmsPhone,
                                                                    style: {
                                                                        width: "100%",
                                                                        height: "40px"
                                                                    },
                                                                    suffixIcon: smsPhoneListLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "w-[16px] h-[16px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]"
                                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                                                        className: "mr-[5px]",
                                                                        src: "/images/user-verify/dropdown.svg",
                                                                        width: 12,
                                                                        height: 0,
                                                                        alt: "dropDown"
                                                                    }),
                                                                    disabled: smsPhoneListDisabled,
                                                                    onChange: handleSelectChange,
                                                                    options: smsPhoneList
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                    disabled: btnDisable,
                                                                    style: {
                                                                        opacity: btnDisable ? 0.7 : 1,
                                                                        background: "#FFCF55",
                                                                        padding: "0 16px",
                                                                        marginLeft: "9px",
                                                                        color: "#1B1C2B",
                                                                        borderRadius: "41px",
                                                                        fontSize: "18px"
                                                                    },
                                                                    onClick: sendSms,
                                                                    children: btnDisable ? sendTime : "Send"
                                                                })
                                                            ]
                                                        }),
                                                        sendContentTips != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "text-[center] mb-[20px] text-[12px] text-[#9A9A9E]",
                                                            children: [
                                                                " ",
                                                                sendContentTips
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                            spinning: loginLoading,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CodeBox, {
                                                                length: 6,
                                                                validator: (input, index)=>{
                                                                    return /\d/.test(input);
                                                                },
                                                                onChange: (e)=>codeSms(e)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                                            children: t("Enter the verification code")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "px-[58px] pt-[54px] pb-[60px]",
                    style: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                src: "/images/apps/apple.svg",
                                alt: "img",
                                className: "w-[60px] h-[68.57px]",
                                width: "30",
                                height: "30"
                            })
                        }),
                        current == 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "max-w-[484px] text-[24px] text-center mt-[30px] text-[#282938] font-[600]",
                                    children: t("Enter the iCloud account and password of the monitored iPhone")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-[335px] mx-auto mt-[35px] flex flex-col items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full flex flex-col",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                className: "w-full h-[48px] bg-[rgba(244,245,246,0.92)] hover:bg-[rgba(244,245,246,0.92)] focus:border-[#454CFF] focus:border placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[20px] px-[15px]",
                                                style: {
                                                    outline: "none"
                                                },
                                                onChange: (e)=>onchangeUserInput(e),
                                                placeholder: t("Apple ID"),
                                                value: useUserName
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full flex flex-col mt-[24px]",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "relative w-full",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                                        className: "w-full h-[48px] bg-[rgba(244,245,246,0.92)] hover:bg-[rgba(244,245,246,0.92)] focus:border-[#454CFF] focus:border placeholder:text-[rgba(0,0,0,0.4)] border-0 rounded-[20px] px-[15px] pr-[45px]",
                                                        type: showPassword ? "text" : "password",
                                                        onChange: (e)=>onchangePassWordInput(e),
                                                        placeholder: t("Password")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                                        src: showPassword ? "/extreme/open.svg" : "/extreme/close.svg",
                                                        width: 18,
                                                        height: 18,
                                                        alt: "",
                                                        className: "absolute top-0 bottom-0 my-auto right-[15px] cursor-pointer",
                                                        onClick: ()=>setShowPassword(!showPassword)
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full my-[24px] flex items-start justify-center rounded-[6px] text-[#F11E34] text-[14px] px-[12px] py-[8px] bg-[rgba(255,0,0,0.05)]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                                    src: "/images/apps/waring.svg",
                                                    className: "flex items-start mt-[5px]",
                                                    alt: "img",
                                                    width: 12,
                                                    height: 12,
                                                    onClick: handleCancel
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-center",
                                                    children: t("A two-step verification code or SMS will be sent to the target iPhone from Apple official")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full flex justify-center items-center",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                className: "".concat(loginLoading ? "opacity-70" : "", " w-full h-[42px] mx-auto bg-[#FFCF55] text-[#222222] text-[16px] font-[600] rounded-[41px] flex justify-center items-center"),
                                                onClick: ()=>{
                                                    if (loginLoading) return;
                                                    login();
                                                },
                                                children: [
                                                    t("Connect"),
                                                    loginLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-[20px] h-[20px] border-[3px] border-[#FFF] border-b-[#FFCF55] rounded-[50%] inline-block box-border animate-spin ml-[16px]"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "steps-content",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    className: "max-w-[484px] text-[24px] text-center mt-[30px] text-[#282938] font-[600]",
                                    children: t("Choose a verification method")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-[310px] mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "w-full h-[44px] flex items-center mt-[15px] mb-[24px]",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(key == "1" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " h-[35px] border-b-[2px] flex items-center cursor-pointer"),
                                                    onClick: ()=>{
                                                        if (key == "1") return;
                                                        setKey("1");
                                                    },
                                                    children: t("Device")
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(key == "2" ? "text-[16px] text-[#2405F2] border-b-[#2405F2]" : "text-[14px] text-[#000] border-b-[#FFF]", " ml-[18px] h-[35px] flex items-center border-b-[2px] cursor-pointer"),
                                                    onClick: ()=>{
                                                        if (key == "2") return;
                                                        if (smsPhoneListDisabled) {
                                                            (0,src_components_Message__WEBPACK_IMPORTED_MODULE_12__/* .messageInfo */ .B)(smsErrorText);
                                                        } else {
                                                            setKey("2");
                                                        }
                                                    },
                                                    children: t("SMS")
                                                })
                                            ]
                                        }),
                                        key == "1" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    spinning: loginLoading,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CodeBox, {
                                                        length: 6,
                                                        validator: (input, index)=>{
                                                            return /\d/.test(input);
                                                        },
                                                        onChange: (e)=>codeDevice(e)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                                    children: t("A verification code has been sent to the target iPhone Enter the verification code")
                                                })
                                            ]
                                        }),
                                        key == "2" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "mb-[24px] flex",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                            defaultValue: defaultSmsPhone,
                                                            style: {
                                                                flex: 1,
                                                                height: "45px"
                                                            },
                                                            suffixIcon: smsPhoneListLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "w-[18px] h-[18px] border-[3px] border-b-[rgba(244,245,246,0.92)] rounded-[50%] inline-block box-border animate-spin mr-[5px]"
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                                                className: "mr-[5px]",
                                                                src: "/images/user-verify/dropdown.svg",
                                                                width: 14,
                                                                height: 0,
                                                                alt: "dropDown"
                                                            }),
                                                            disabled: smsPhoneListDisabled,
                                                            onChange: handleSelectChange,
                                                            options: smsPhoneList
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                            disabled: btnDisable,
                                                            className: "min-w-[85px]",
                                                            style: {
                                                                opacity: btnDisable ? 0.7 : 1,
                                                                background: "#FFCF55",
                                                                padding: "0 21px",
                                                                marginLeft: "9px",
                                                                color: "#1B1C2B",
                                                                borderRadius: "41px",
                                                                fontSize: "18px"
                                                            },
                                                            onClick: sendSms,
                                                            children: btnDisable ? sendTime : t("Send")
                                                        })
                                                    ]
                                                }),
                                                sendContentTips != "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    className: "text-[center] mb-[24px] text-[12px] text-[#9A9A9E]",
                                                    children: [
                                                        " ",
                                                        sendContentTips
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    spinning: loginLoading,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CodeBox, {
                                                        length: 6,
                                                        validator: (input, index)=>{
                                                            return /\d/.test(input);
                                                        },
                                                        onChange: (e)=>codeSms(e)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "mt-[24px] text-center text-[12px] text-[#9A9A9E]",
                                                    children: t("Enter the verification code")
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            lockedFlowModals,
            contextHolder,
            isWarn && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed top-0 right-0 left-0 bottom-0 bg-black bg-opacity-75 flex items-center justify-center z-[1201]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative w-[700px] h-auto bg-white rounded-[8px] pb-10 pt-[60px] px-6 smj:w-full smj:mx-3",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_10___default()), {
                                    src: "/warn.svg",
                                    width: 46,
                                    height: 46,
                                    alt: "warn"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "ml-2 text-black text-[26px] font-[700]",
                                    children: t("Warning")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-6 text-black text-[20px]",
                            children: t("The use of government-affiliated email addresses")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "mt-6 text-black text-[20px]",
                            children: t("To proceed")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex justify-end mt-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "h-[50px] w-[fit-content] px-5 bg-[#50e3c2] rounded-[6px] flex justify-center items-center text-black text-[20px] font-[700]",
                                onClick: ()=>setIsWarn(false),
                                children: t("I Understand")
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AdvancedDownloadForm);


/***/ }),

/***/ 20725:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tips":"user-verify_tips__ckMny","icon":"user-verify_icon__eUfpT","tipsText":"user-verify_tipsText__P949c","formBox":"user-verify_formBox__nhhg9","h1":"user-verify_h1__ZOgcB","pText":"user-verify_pText__ftdPd","apple":"user-verify_apple__rjGLT","password":"user-verify_password__893bq","connectBox":"user-verify_connectBox__Gp81h","connect":"user-verify_connect__rHy5D"};

/***/ })

}]);